import React from "react";
import { AlertTriangle } from "lucide-react";

export default function ParticularWarningModal({
  open,
  title = "Este horário é particular",
  message = "Esse horário não está vinculado ao seu convênio.",
  onConfirm,
  onCancel,
  confirmLabel = "Continuar como particular",
  cancelLabel = "Voltar",
}) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4"
      role="dialog"
      aria-modal="true"
    >
      <div className="w-full max-w-md bg-white rounded-2xl sm:rounded-3xl shadow-xl overflow-hidden fade-up">
        <div className="p-6">
          <div className="w-12 h-12 rounded-full bg-amber-100 text-amber-600 flex items-center justify-center">
            <AlertTriangle size={24} />
          </div>

          <h2
            className="text-lg font-bold text-slate-900 mt-4"
            style={{ fontFamily: "Manrope" }}
          >
            {title}
          </h2>

          <p className="text-sm text-slate-600 mt-2">{message}</p>

          <div className="mt-4 flex items-start gap-2 bg-amber-50 border border-amber-100 rounded-xl px-4 py-3">
            <AlertTriangle size={16} className="text-amber-600 mt-0.5 shrink-0" />
            <p className="text-sm text-amber-800 font-medium">
              Esse agendamento poderá ter cobrança no dia do atendimento.
            </p>
          </div>
        </div>

        <div className="p-4 sm:p-6 pt-0 flex flex-col-reverse sm:flex-row gap-3">
          <button
            type="button"
            onClick={onCancel}
            className="w-full h-12 rounded-xl border border-slate-200 bg-white text-slate-700 font-medium hover:bg-slate-50 active:scale-[0.99] transition-all"
          >
            {cancelLabel}
          </button>

          <button
            type="button"
            onClick={onConfirm}
            className="w-full h-12 rounded-xl bg-amber-500 text-white font-semibold shadow-sm hover:bg-amber-600 active:scale-[0.99] transition-all"
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
